import { __ } from '@wordpress/i18n';

/*
** 스크립트 정의
*/
const singlePostModule = {
  init: function() {
    this.set_comment_form()
  },
  set_comment_form: function () {

    const comment = document.querySelector('.wp-block-post-comments-form #comment');
    if (comment) {
      comment.setAttribute('placeholder', __('* 댓글을 입력하세요.', 'hellopanda-theme-expand'));
      comment.setAttribute('rows', '5');
    }

    const author = document.querySelector('.wp-block-post-comments-form #author');
    if (author) {
      author.setAttribute('placeholder', __('* 이름 입력', 'hellopanda-theme-expand'));
    }

    const email = document.querySelector('.wp-block-post-comments-form #email');
    if (email) {
      email.setAttribute('placeholder', __('* 이메일 입력', 'hellopanda-theme-expand'));
    }

    const url = document.querySelector('.wp-block-post-comments-form #url');
    if (url) {
      url.setAttribute('placeholder', __('웹사이트 입력', 'hellopanda-theme-expand'));
    }

  }
};
singlePostModule.init();